// @ts-strict-ignore
import { MetaElementUsageIdentityVO } from '@shared/vo/meta-element.vo';
import { Connection } from '@3d-scene/model3d/connection';
import { ArticleUsageVO } from '@article/model/vo/article.vo';
import { ArticleUsageUtils } from '@article/util/article-usage-utils';
import { Rectangle3D } from '@3d-scene/model/rectangle-3d';
import { PropertyVO } from '@project/components/article/model/vo/property.vo';
import { ConnectionInfoUtils } from '@3d-scene/model3d/util/connection-info-utils';
import { ConnectionInfoService } from '@3d-scene/model3d/service/connection-info.service';

export class ConnectionCubeSearchRequirements {
  public cubeUID: string;
  private _identity: MetaElementUsageIdentityVO;
  public articleId: number;
  public connectionRequirements: PropertyVO[];
  // index of the related requirements in the "global" requirements list
  public globalRequirementIndex: number;

  private _cube: Connection = null;

  constructor(private connectionInfoService: ConnectionInfoService, connectionCube: Connection, observeCompositeArticleId: boolean = true) {
    if (connectionCube) {
      this.cubeUID = connectionCube.uid;
      this.identity = MetaElementUsageIdentityVO.create(connectionCube.articleContainer.articleGUID, connectionCube.connectionName);
      const articleUsage: ArticleUsageVO = connectionCube.articleContainer.articleUsage;
      if (articleUsage != null) {
        this.articleId = observeCompositeArticleId ? ArticleUsageUtils.getArticleIdFromArticleUsage(articleUsage) : articleUsage.articleId;
      }
      this._cube = connectionCube;
    }
  }

  public set identity(value: MetaElementUsageIdentityVO) {
    if (!this._identity || !this._identity.equals(value)) {
      this._identity = value;
      this._cube = null;
    }
  }

  public get identity(): MetaElementUsageIdentityVO {
    return this._identity;
  }

  public get articleUsageId(): string {
    return !this.identity ? null : this.identity.articleUsageId;
  }

  public getConnectionCube(): Connection {
    if (this._cube) {
      return this._cube;
    }
    return !this.identity ? null : this.connectionInfoService.findConnectionByIdentity(this.identity);
  }

  public getConnectionRectangle(): Rectangle3D {
    const connectionCube: Connection = this.getConnectionCube();
    return !connectionCube ? null : connectionCube.compositionRectangle;
  }

  public isRangeOnLineConnection(): boolean {
    const connectionCube: Connection = this.getConnectionCube();
    if (!connectionCube) {
      return false;
    }
    return ConnectionInfoUtils.isRangeOnLineConnection(connectionCube.metaElementVO);
  }
}
